'use client'

import { DropdownGroupOption } from '@/types'
import Image from 'next/image'
import { useState } from 'react'
import SideSelect from '../SideSelect'

interface InputDropdownProps {
  inputId: string
  selectionId: string
  placeholder?: string
  isRequire?: boolean
  icon?: string | null
  dropdownLabel: string
  dropdownLeftSide?: boolean
  canSearchDropdown?: boolean
  isInputNumber?: boolean
  initValue: number | string
  selectedOption: any
  options: { value: string; label: string }[] | DropdownGroupOption[]
  updateValue: (key: string, value: string | number) => void
}

export default function InputDropdown({
  inputId,
  selectionId,
  placeholder = '',
  isRequire = false,
  icon = null,
  dropdownLabel,
  dropdownLeftSide,
  canSearchDropdown = false,
  isInputNumber = false,
  options,
  initValue,
  selectedOption,
  updateValue,
}: InputDropdownProps) {
  const [inputValue, setInputValue] = useState(initValue)
  const [selectedValue, setSelectedValue] = useState(selectedOption)

  const updateInputValue = (value: string) => {
    const convertValue = isInputNumber ? Number(value.replace(/,/g, '')) : value
    setInputValue(convertValue)
    updateValue(inputId, convertValue)
  }

  const updateSideSelectValue = (data: any) => {
    setSelectedValue(data)
    updateValue(selectionId, data.value)
  }

  return (
    <div
      className={`${dropdownLeftSide ? 'flex-row-reverse' : ''} flex items-center`}
    >
      <div className="relative w-full">
        {icon && (
          <div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
            <Image
              src={icon}
              alt=""
              width={16}
              height={16}
              style={{
                maxWidth: '100%',
                height: 'auto',
              }}
            />
          </div>
        )}
        <input
          value={inputValue ? inputValue.toLocaleString() : ''}
          onChange={(e) => {
            updateInputValue(e.target.value)
          }}
          type="text"
          id={inputId}
          className={`${dropdownLeftSide ? 'rounded-e-lg border-s-0' : 'rounded-s-lg border-e-0'} ${icon ? 'ps-10' : ''} block w-full p-2.5 text-sm text-gray-900 border border-gray-300 bg-white focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500`}
          placeholder={placeholder}
          required={isRequire}
        />
      </div>
      <SideSelect
        selectionId={selectionId}
        dropdownLabel={dropdownLabel}
        dropdownLeftSide={dropdownLeftSide}
        canSearchDropdown={canSearchDropdown}
        options={options}
        value={selectedValue}
        onSelectValue={(value) => {
          updateSideSelectValue(value)
        }}
      />
    </div>
  )
}
